export default __webpack_public_path__ + "static/media/artboard3.6ab32a21.png";